import * as React from "react"
import { useTranslation } from "react-i18next"
import Element from "@bappweb/element"
import Page from "@components/globalmodules/page"

const Apis = () => {
  const { t } = useTranslation()

  return (
    <Page>
      <Element type="h1">{t("API's")}</Element>
    </Page>
  )
}

export default Apis
